module.exports = __webpack_public_path__ + "static/media/icon_clipboard.09ccf490.svg";